import { axios } from 'data';

import {
  StatisticsFeesParams,
  StatisticsFeesResponse,
  StatisticsPaymentsParams,
  StatisticsPaymentsResponse,
  StatisticsPayoutsParams,
  StatisticsPayoutsResponse,
  StatisticsVolumesParams,
  StatisticsVolumesResponse,
} from 'types/services';

import { prepareTimezonableParams } from './helpers';

const getFees = async (params: StatisticsFeesParams) => {
  params = prepareTimezonableParams(params);

  const response = await axios.get<StatisticsFeesResponse>('/stats/fees', { params });

  return response.data.list;
};

const getPayments = async (params: StatisticsPaymentsParams) => {
  params = prepareTimezonableParams(params);

  const response = await axios.get<StatisticsPaymentsResponse>('/stats/payments', { params });

  return response.data.list;
};

const getPayouts = async (params: StatisticsPayoutsParams) => {
  params = prepareTimezonableParams(params);

  const response = await axios.get<StatisticsPayoutsResponse>('/stats/payouts', { params });

  return response.data.list;
};

const getVolumes = async (params: StatisticsVolumesParams) => {
  params = prepareTimezonableParams(params);

  const response = await axios.get<StatisticsVolumesResponse>('/stats/volumes', { params });

  return response.data.list;
};

const statisticsService = {
  getFees,
  getPayments,
  getPayouts,
  getVolumes,
};

export default statisticsService;
